import React from 'react';

import { useIntl } from '@utils/intl';
import { BookingIcon } from '@views/shared/BookingIcon';
import { BOOK_CATEGORY_TRAVEL, getBookingIcon } from '@views/shared/consts';
import { Panel } from '@views/Book/Bookings/Panel';
import { useGoTo } from '@views/shared/utils/useGoTo';

export default function TravelDay() {
  const { t } = useIntl();

  const { goToBookingPage } = useGoTo();

  return (
    <Panel
      icon={<BookingIcon name={getBookingIcon(BOOK_CATEGORY_TRAVEL)} />}
      name={t('Home.ActiveBookings.Booking.title.travelDay')}
      onAction={() => goToBookingPage({ type: BOOK_CATEGORY_TRAVEL })}
    />
  );
}
